var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInsuranceCardinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 10"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 9,
  x: 1,
  y: 0.5,
  stroke: "#00B684",
  strokeWidth: 0.5,
  className: "card-outline",
  rx: 1.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 1,
  x: 2,
  y: 1.5,
  fill: "#00B684",
  className: "card-detail",
  rx: 0.5
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 1,
  x: 2,
  y: 3.5,
  fill: "#00B684",
  className: "card-detail",
  rx: 0.5
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 1,
  x: 4,
  y: 3.5,
  fill: "#00B684",
  className: "card-detail",
  rx: 0.5
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 1,
  x: 7,
  y: 7.5,
  fill: "#00B684",
  className: "card-detail",
  rx: 0.5
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 1,
  x: 2,
  y: 7.5,
  fill: "#00B684",
  className: "card-detail",
  rx: 0.5
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 1,
  x: 13,
  y: 3.501,
  fill: "#00B684",
  className: "card-detail",
  rx: 0.5
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 1,
  x: 9,
  y: 7.5,
  fill: "#00B684",
  className: "card-detail",
  rx: 0.5
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 1,
  x: 15,
  y: 3.5,
  fill: "#00B684",
  className: "card-detail",
  rx: 0.5
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 1,
  x: 11,
  y: 7.5,
  fill: "#00B684",
  className: "card-detail",
  rx: 0.5
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 1,
  x: 15,
  y: 7.5,
  fill: "#00B684",
  className: "card-detail",
  rx: 0.5
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 1,
  x: 2,
  y: 5.5,
  fill: "#00B684",
  className: "card-detail",
  rx: 0.5
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 1,
  x: 4,
  y: 1.5,
  fill: "#00B684",
  className: "card-detail",
  rx: 0.5
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 1,
  x: 13,
  y: 5.5,
  fill: "#00B684",
  className: "card-detail",
  rx: 0.5
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 1,
  x: 6,
  y: 1.5,
  fill: "#00B684",
  className: "card-detail",
  rx: 0.5
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 1,
  x: 15,
  y: 5.5,
  fill: "#00B684",
  className: "card-detail",
  rx: 0.5
})));
export default SvgInsuranceCardinline;